export const mobileQuery = window.matchMedia('(max-width: 768px)');
export const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
